<template>
  <div class="columns is-multiline">
    <div class="notification column is-full" v-for="(critical, index) in criticals" :key="index">
      <div class="content is-small">
        <span class="title is-6">
          {{ critical.name }}
          <b-tag :type="checkLabel(critical.status)">{{ critical.label }}</b-tag>
        </span>
        <div v-html="critical.value"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    criticals: {
      required: true
    }
  },
  methods: {
    checkLabel(status) {
      if (status === "success") {
        return "is-success";
      } else if (status === "danger") {
        return "is-danger";
      } else if (status === "warning") {
        return "is-warning";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
